// NOTE: the canonical definition of these types now lives in
// `src/types/IdentificationType.ts` so the shared IdentificationTypeLoader
// and other consumers (student file, academic configuration, etc.) can
// reuse them. We re-export here for backwards compatibility with existing
// imports from TeacherActivation/types.
export type {
  IdentificationType,
  IdentificationTypeResponse,
} from '../../../../types/IdentificationType';

export interface BaseOption {
  id: string;
  name: string;
  regionId?: number;
}

export interface OptionsResponse {
  tenanCountry: BaseOption;
  countries: BaseOption[];
  regions: BaseOption[];
  cities: BaseOption[];
  communes: BaseOption[];
  healthInstitutions: BaseOption[];
  identificationTypes: BaseOption[];
  campuses: BaseOption[];
  schools: BaseOption[];
  // Statics
  genders: BaseOption[];
  areaTypes: BaseOption[];
  healthSystems: BaseOption[];
  maritalStatus: BaseOption[];
}

export type OptionsResponseKey = keyof OptionsResponse;

export enum TeacherRoles {
  TUTOR = 'TTR',
  TEACHER = 'TCH',
  TEACHER_TUTOR = 'TCH_TTR',
}

export const teacherRolesOptions = [
  { value: TeacherRoles.TUTOR, label: 'Tutor' },
  { value: TeacherRoles.TEACHER, label: 'Docente' },
  { value: TeacherRoles.TEACHER_TUTOR, label: 'Docente - Tutor' },
];

export type TeacherRole = typeof TeacherRoles[keyof typeof TeacherRoles];
